import { useParams } from "react-router-dom";
import { useFormLogic } from "../../../hooks/useFormLogic";
import useBranchLogic from "./useBranchLogic";
import ReusableForm from "../../../components/ReusableForm/ReusableForm";
import { PropagateLoader } from "react-spinners";
import PopUp from "../../../components/PopUp/PopUp";

function BranchDetailsPage() {
  const { id } = useParams();

  const { apiRoute, initFields, onlyForm, getPromises, tabs, tabsData } =
    useBranchLogic();

  const {
    loading,
    editFields,
    isSaving,
    setIsSaving,
    handleSubmit,
    onFormCancel,
    edit,
    editId,
    handleRelatedData,
    handleSingleCreateData,
    formDataChanged,
    callPopUp,
    disableParams,
    reservationCode,
    popupData,
    resetPopUp,
  } = useFormLogic({
    apiRoute,
    id,
    initFields,
    onlyForm,
    getPromises,
    tabs,
  });

  return (
    <div>
      {loading ? (
        <div className="flex h-full justify-center align-center">
          <PropagateLoader color="#5729BC" />
        </div>
      ) : (
        <ReusableForm
          formType={"edit"}
          fields={editFields}
          isSaving={isSaving}
          setIsSaving={setIsSaving}
          onSubmit={handleSubmit}
          onCancel={onFormCancel}
          tabsData={
            edit && editId ? tabsData : tabsData?.filter((x) => !x.hideNew)
          }
          handleRelatedData={handleRelatedData}
          handleSingleCreateData={handleSingleCreateData}
          updateShowFields={formDataChanged}
          id={editId}
          onlyForm={onlyForm}
          callPopUp={callPopUp}
          hideSubmitActions={true}
          headerSaveBotton={true}
          disableConditionsFunction={disableParams}
          reservationCode={reservationCode}
        />
      )}
      <PopUp
        autoClose={popupData.autoClose}
        isError={popupData.isError}
        title={popupData.title}
        description={popupData.description}
        formOptions={popupData.formOptions}
        takeActionText={popupData.takeActionText}
        takeActionFun={popupData.takeActionFun}
        showPopUp={popupData.showPopUp}
        hidePopUp={resetPopUp}
        formSubmit={popupData.formSubmit}
        formConcatData={popupData.formConcatData}
        propName={popupData.propName}
        disabledForm={popupData.disabledForm}
        hideCancel={popupData.hideCancel}
        hideMainButton={popupData.hideMainButton}
        showLoading={popupData.hideMainButton}
        progressValue={popupData.progressValue}
        overflow={popupData.overflow}
        expand={popupData.expand}
      >
        {popupData.children}
      </PopUp>
    </div>
  );
}

export default BranchDetailsPage;
